<template>
    <!-- ========== FOOTER ========== -->
  <footer class="">
    <HeroSection theme="footer" class="text-white-70">
      <div class="px-lg-8 px-md-6 px-4">
        <div class="space-top-2 space-bottom-0">
          <div class="w-md-75 text-lg-center mx-lg-auto">
            <p class="text-white text-uppercase">YOUR HOME MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE</p>
          </div>
        </div>
        <div class="space-top-1 space-bottom-1 space-bottom-lg-1">
          <div class="row justify-content-lg-between">
            <div class="col-md-3 col-sm-6 col-xs-12 col-lg mb-5 mb-lg-0">
              <h5 class="text-white">Company</h5>
              <!-- Nav Link -->
              <ul class="nav nav-sm nav-x-0 nav-white flex-column">
                <li class="nav-item"><a class="nav-link" href="#">About Us</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Careers <span class="badge badge-primary ml-1">We're hiring</span></a></li>
                <li class="nav-item"><a class="nav-link" href="#">Blog</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Press</a></li>
              </ul>
              <!-- End Nav Link -->
            </div>
  
            <div class="col-md-3 col-sm-6 col-xs-12 col-lg mb-5 mb-lg-0">
              <h5 class="text-white">Services</h5>
  
              <!-- Nav Link -->
              <ul class="nav nav-sm nav-x-0 nav-white flex-column">
                <li class="nav-item"><a class="nav-link" href="#">MortgageWatch<sup style="margin-left: -6px; margin-right: 12px;">TM</sup></a></li>
                <li class="nav-item"><a class="nav-link" href="#">MortgageWatch<sup style="margin-left: -6px; margin-right: 10px;">TM</sup> for Brokers</a></li>
                <li class="nav-item"><a class="nav-link" href="#">MortgageWatch<sup style="margin-left: -6px; margin-right: 10px;">TM</sup> API</a></li>
              </ul>
              <!-- End Nav Link -->
            </div>
  
            <div class="col-md-3 col-sm-6 col-xs-12 col-lg mb-5 mb-lg-0">
              <h5 class="text-white">Resources</h5>
  
              <!-- Nav Link -->
              <ul class="nav nav-sm nav-x-0 nav-white flex-column">
                <li class="nav-item"><a class="nav-link" href="#">Learn</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Help</a></li>
                <li class="nav-item"><a class="nav-link" href="#">Status</a></li>
              </ul>
              <!-- End Nav Link -->
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12 col-lg">
              <!-- Nav Link -->
              <ul class="nav nav-sm nav-x-0 nav-white flex-column">
                <li class="nav-item mb-3">
                  <router-link
                      to="/products/remortgage"
                      v-slot="{ href, route, navigate }">
                    <button class="btn btn-sm btn-light btn-block" :href="href" @click="navigate">Remortgage Deals</button>
                  </router-link>
                </li>
                <li class="nav-item mb-3">
                  <router-link
                      to="/mortgage-watch/getting-started"
                      v-slot="{ href, route, navigate }">
                    <button class="btn btn-sm btn-light btn-block" :href="href" @click="navigate">MortgageWatch Alert</button>
                  </router-link>
                </li>
              </ul>
              <!-- End Nav Link -->
            </div>
  
          </div>
        </div>
        <hr class="opacity-xs my-0 mb-2">
        <div class="space-0">
          <div class="row align-items-md-center">
            <div class="col-md-6 mb-4 mb-md-0">
              <!-- Nav Link -->
              <ul class="nav nav-sm nav-white nav-x-sm align-items-center">
                <li class="nav-item">
                  <a class="nav-link" href="#">Privacy &amp; Policy</a>
                </li>
                <li class="nav-item opacity mx-3">/</li>
                <li class="nav-item">
                  <a class="nav-link" href="#">Terms &amp; Conditions</a>
                </li>
              </ul>
              <!-- End Nav Link -->
            </div>
  
            <div class="col-md-6 text-md-right">
              <ul class="list-inline mb-0">
                <!-- Social Networks -->
                <li class="list-inline-item">
                  <a class="btn btn-xs btn-icon btn-soft-light" href="#">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a class="btn btn-xs btn-icon btn-soft-light" href="#">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a class="btn btn-xs btn-icon btn-soft-light" href="#">
                    <i class="fab fa-linkedin"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a class="btn btn-xs btn-icon btn-soft-light" href="#">
                    <i class="fab fa-github"></i>
                  </a>
                </li>
                <!-- End Social Networks -->
              </ul>
            </div>
          </div>
          <!-- Copyright -->
          <div class="w-md-75 text-lg-center mx-lg-auto mt-3">
            <p class="text-white opacity-sm small">© 2020 Cheap Mortgage Club. All rights reserved.</p>
            <p class="text-white opacity-sm small">When you visit or interact with our sites, services or tools, we or our authorised service providers may use cookies for storing information to help provide you with a better, faster and safer experience and for marketing purposes.</p>
          </div>
          <!-- End Copyright -->
        </div>
      </div>
    </HeroSection>
  </footer>
    <!-- ========== END FOOTER ========== -->
</template>
<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  components: {HeroSection}
}
</script>